import { c as _c } from "react-compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import usePrevious from '../../../hooks/usePrevious';
import { useEmbeddedCommentClickListener } from '../hooks/useEmbeddedCommentClickListener';
import { useToggleOpenPopover } from '../hooks/useToggleOpenPopover';
import { useEmbeddedCommentHandlers } from '../hooks/useEmbeddedCommentHandlers';
import useWindowScrollListener from '../../../hooks/useWindowScrollListener';
import { jsx as _jsx } from "react/jsx-runtime";
export function useControlledEmbeddedCommentPopover(t0) {
  "use memo";

  const $ = _c(31);
  const {
    moduleId,
    description,
    collaborationSidebarState,
    onUpdateCollaborationSidebarState,
    isOpen,
    onOpenChange,
    popoverPlacement: t1,
    nodeRef
  } = t0;
  const popoverPlacement = t1 === undefined ? "top" : t1;
  const {
    isEmbeddedPopoverOpen
  } = collaborationSidebarState;
  const prevIsOpen = usePrevious(isOpen);
  const prevIsEmbeddedPopoverOpen = usePrevious(isEmbeddedPopoverOpen);
  const [childElement, setChildElement] = useState(null);
  let t2;
  let t3;
  if ($[0] !== nodeRef) {
    t2 = () => {
      if (nodeRef !== null && nodeRef !== void 0 && nodeRef.current) {
        setChildElement(nodeRef.current);
        return;
      }
    };
    t3 = [nodeRef];
    $[0] = nodeRef;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== childElement || $[4] !== collaborationSidebarState || $[5] !== description || $[6] !== moduleId || $[7] !== onUpdateCollaborationSidebarState || $[8] !== popoverPlacement) {
    t4 = {
      embeddedCommentWrapper: childElement,
      onUpdateCollaborationSidebarState,
      collaborationSidebarState,
      moduleId,
      metaDescription: description,
      placement: popoverPlacement
    };
    $[3] = childElement;
    $[4] = collaborationSidebarState;
    $[5] = description;
    $[6] = moduleId;
    $[7] = onUpdateCollaborationSidebarState;
    $[8] = popoverPlacement;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const toggleOpenPopover = useToggleOpenPopover(t4);
  let t5;
  let t6;
  if ($[10] !== isOpen || $[11] !== prevIsOpen || $[12] !== toggleOpenPopover) {
    t5 = () => {
      if (isOpen !== prevIsOpen) {
        toggleOpenPopover(isOpen);
      }
    };
    t6 = [isOpen, prevIsOpen, toggleOpenPopover];
    $[10] = isOpen;
    $[11] = prevIsOpen;
    $[12] = toggleOpenPopover;
    $[13] = t5;
    $[14] = t6;
  } else {
    t5 = $[13];
    t6 = $[14];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[15] !== isEmbeddedPopoverOpen || $[16] !== onOpenChange || $[17] !== prevIsEmbeddedPopoverOpen) {
    t7 = () => {
      if (!isEmbeddedPopoverOpen && prevIsEmbeddedPopoverOpen && onOpenChange) {
        onOpenChange(isEmbeddedPopoverOpen);
      }
    };
    t8 = [onOpenChange, isEmbeddedPopoverOpen, prevIsEmbeddedPopoverOpen];
    $[15] = isEmbeddedPopoverOpen;
    $[16] = onOpenChange;
    $[17] = prevIsEmbeddedPopoverOpen;
    $[18] = t7;
    $[19] = t8;
  } else {
    t7 = $[18];
    t8 = $[19];
  }
  useEffect(t7, t8);
  let t9;
  if ($[20] !== childElement || $[21] !== onUpdateCollaborationSidebarState || $[22] !== popoverPlacement) {
    t9 = {
      popoverPlacement,
      embeddedCommentWrapper: childElement,
      onUpdateCollaborationSidebarState
    };
    $[20] = childElement;
    $[21] = onUpdateCollaborationSidebarState;
    $[22] = popoverPlacement;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const {
    updateEmbeddedCommentCoordinates
  } = useEmbeddedCommentHandlers(t9);
  let t10;
  if ($[24] !== isOpen || $[25] !== updateEmbeddedCommentCoordinates) {
    t10 = {
      listenToScroll: isOpen,
      onScroll: updateEmbeddedCommentCoordinates,
      useCapture: true
    };
    $[24] = isOpen;
    $[25] = updateEmbeddedCommentCoordinates;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  useWindowScrollListener(t10);
  let t11;
  if ($[27] !== isOpen || $[28] !== onUpdateCollaborationSidebarState || $[29] !== prevIsOpen) {
    t11 = {
      onUpdateCollaborationSidebarState,
      isOpen,
      prevIsOpen
    };
    $[27] = isOpen;
    $[28] = onUpdateCollaborationSidebarState;
    $[29] = prevIsOpen;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  useEmbeddedCommentClickListener(t11);
}
export default function ControlledEmbeddedCommentPopover(props) {
  var _props$nodeRef;
  const ref = useRef(null);
  useControlledEmbeddedCommentPopover(Object.assign({}, props, {
    nodeRef: (_props$nodeRef = props.nodeRef) !== null && _props$nodeRef !== void 0 ? _props$nodeRef : ref
  }));
  return /*#__PURE__*/_jsx("span", {
    ref: ref,
    children: props.children
  });
}